import { t } from "i18next";
import { ws } from "../../../utils/common";
import { isValidPassword, isValidEmail } from "../../../utils/validation";

import { registerPushNotifications } from "../../../utils/pushManager";
import { setGlobalState } from "../../../utils/state";

export const loginWS = async ({ email, password, mobile = false }) => {
  if (!isValidPassword(password)) {
    throw new Error(t("validation.password_not_valid"));
  }

  if (!isValidEmail(email)) {
    throw new Error(t("validation.email_not_valid"));
  }

  const res = await ws(
    "POST",
    process.env.REACT_APP_ENDPOINT + "auth/login",
    null,
    {
      email,
      password,
      mobile,
    },
    false
  );

  if (res.error) {
    throw res.data;
  } else {
    setGlobalState("admin", res.data.info.admin);

    localStorage.setItem("accessToken", res.data.accessToken);
    localStorage.setItem("name", res.data.info.name);
    localStorage.setItem("surname", res.data.info.surname);
    localStorage.setItem("admin", res.data.info.admin);
    localStorage.setItem(
      "imageProfile",
      res.data.info.image
        ? "data:" + res.data.info.image_type + ";base64," + res.data.info.image
        : "/no_img.png"
    );

    //Faccio apparire l'acconsento per l'invio delle notifiche
    const userLoggedIn = localStorage.getItem("accessToken");
    if (userLoggedIn) {
      registerPushNotifications().catch(console.error);
    }

    // Attendere e controllare che la session sia scritta
    window.location.replace("/");

    return;
  }
};
